import styled from 'styled-components'

export const StyledPaymentRequestButton = {
  Wrapper: styled.div`
    & * {
      border-radius: 16px;
    }
  `,
}
